import { render, staticRenderFns } from "./editQuestion.vue?vue&type=template&id=23094493&"
import script from "./editQuestion.vue?vue&type=script&lang=js&"
export * from "./editQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports